import React, { memo, useMemo } from 'react';

const EmpBankAddressComponent = memo(({ empData }) => {
  const tabs = useMemo(() => [
    {
      id: 'Corresponding',
      label: 'Corresponding Address',
      content: [
        { label: 'Address', value: empData?.PresentAddressLine || '' },
        { label: 'City', value: empData?.PresentCity || '' },
        { label: 'State', value: empData?.PresentState || '' },
        { label: 'Zip', value: empData?.PresentZipCode || '' },
        { label: 'Country', value: empData?.PresentCountry || '' },
      ]
    },
    {
      id: 'base',
      label: 'Permanent Address',
      content: [
        { label: 'Address', value: empData?.PermanentAddressLine || '' },
        { label: 'City', value: empData?.PermanentCity || '' },
        { label: 'State', value: empData?.PermanentState || '' },
        { label: 'Zip', value: empData?.PermanentZipCode || '' },
        { label: 'Country', value: empData?.PermanentCountry || '' },
      ]
    },
    {
      id: 'forum',
      label: 'My Banking',
      content: [
        { label: 'Bank Name', value: empData?.BankName || '' },
        { label: 'Branch Address', value: empData?.BankBranchName || '' },
        { label: 'Account No', value: empData?.BankAccountNo || '' },
        { label: 'IFSC Code', value: empData?.BankIFSCCode || '' },
        { label: 'Contact', value: empData?.BankContact || '' },
      ]
    }
  ], [empData]);

  return (
    <div className="container-fluid p-0 mt-2">
      <div className="p-0 forum-tab">
        <ul className="nav nav-tabs overflow multi-tabs" role="tablist">
          {tabs.map((tab, index) => (
            <li key={tab.id} className="nav-item-child" role="presentation" style={{ marginLeft: '3px' }}>
              <button
                className={`nav-link forum-child-tab-btn ${index === 0 ? 'active' : ''}`}
                id={`${tab.id}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#${tab.id}`}
                type="button"
                role="tab"
                aria-controls={tab.id}
                aria-selected={index === 0}
              >
                <strong>{tab.label}</strong>
              </button>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="emp-forum_sect">
        <div className="tab-content" id="myTabContent">
          {tabs.map((tab, index) => (
            <div
              key={tab.id}
              className={`tab-pane fade ${index === 0 ? 'show active' : ''}`}
              id={tab.id}
              role="tabpanel"
              aria-labelledby={`${tab.id}-tab`}
            >
              <div className="card-body">
                <table className="table table-bordered table-hover">
                  <tbody className="address-table">
                    {tab.content.map((item, i) => (
                      <tr key={i}>
                        <th className="bg-light" style={{ width: "150px" }}>
                          {item.label}
                        </th>
                        <td>{item.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default EmpBankAddressComponent;